var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Popup } from "@/shared/presentation/components/popup";
import { NotificationContext } from "@/shared/presentation/context-api/providers/notification";
import { CaretDown } from "@reverb-ui/icons-react";
import { Box, Button, Center, Flex, List, ListItem, Spinner, Text, } from "@reverb-ui/react";
import { format } from "date-fns";
import React, { useContext, useEffect, useState } from "react";
import Search from "@/assets/images/search.svg";
import { Home } from "@reverb-ui/icons-react";
import { I18nextProvider, useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import i18n from "../../../main/i18n/config";
import { notifications_en } from "../../../main/i18n/en";
import { notifications_pt_br } from "../../../main/i18n/pt-br";
export var NotificationContainer = function () {
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var t = useTranslation("notifications").t;
    var _b = useContext(NotificationContext), notifications = _b.notifications, loadMoreNotifications = _b.loadMoreNotifications, readNotifications = _b.readNotifications;
    var history = useHistory();
    var _c = useState(null), openedNotification = _c[0], setOpenedNotification = _c[1];
    var loadMore = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadMoreNotifications()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var goHome = function () {
        history.push("/home");
    };
    useEffect(function () {
        var ids = notifications.data
            .filter(function (notification) { return !notification.read; })
            .map(function (notification) { return notification.recipientId; });
        if (ids.length === 0)
            return;
        readNotifications(ids, new Date());
    }, [notifications, readNotifications]);
    useEffect(function () {
        i18n.addResourceBundle("en", "notifications", notifications_en);
        i18n.addResourceBundle("pt", "notifications", notifications_pt_br);
        setLoading(false);
    }, []);
    return (React.createElement(I18nextProvider, { i18n: i18n }, loading ? (React.createElement(Center, { w: "100%", h: "100%" },
        React.createElement(Spinner, null))) : (React.createElement(Box, { px: "20%", py: "8" },
        React.createElement(Box, { bgColor: "white", borderRadius: "5", py: "6", px: "10", boxShadow: "0px 3px 6px 1px rgba(0,0,0,0.1)" },
            React.createElement(Text, { fontWeight: "bold", fontSize: "3xl" }, t("notifications")),
            notifications.data.length === 0 && (React.createElement(Flex, { flexDirection: "column", alignItems: "center", mt: 20 },
                React.createElement(Search, null),
                React.createElement(Text, { mt: 4, mb: 12, color: "gray.500" }, t("no-notifications")),
                React.createElement(Button, { leftIcon: React.createElement(Home, null), variant: "outline", onClick: goHome }, "Home"))),
            React.createElement(List, { spacing: 4, mt: 4 }, notifications.data.map(function (notification, index) { return (React.createElement(ListItem, { onClick: function () { return setOpenedNotification(notification); }, key: index, bgColor: !notification.read && "gray.100", cursor: "pointer", borderRadius: 5, py: "3", px: "6", d: "flex", justifyContent: "space-between", alignItems: "center" },
                React.createElement(Flex, { alignItems: "flex-start", flexDir: "column" },
                    React.createElement(Text, { fontWeight: !notification.read && "bold", color: "gray.800", fontSize: "lg" }, notification.subject),
                    React.createElement(Text, { fontSize: "sm", color: "gray.500", mt: "4" }, notification.message)),
                React.createElement(Text, { ml: "4" }, format(new Date(notification.createdAt), "dd/MM")))); })),
            notifications.data.length < notifications.meta.total && (React.createElement(Center, { mt: 6 },
                React.createElement(Button, { rightIcon: React.createElement(CaretDown, null), variant: "outline", onClick: loadMore }, t("load-more"))))),
        React.createElement(Popup, { title: openedNotification === null || openedNotification === void 0 ? void 0 : openedNotification.subject, message: openedNotification === null || openedNotification === void 0 ? void 0 : openedNotification.message, onClose: function () { return setOpenedNotification(null); }, isOpen: !!openedNotification })))));
};
